import React, { useState, useEffect, useCallback } from "react";
import CMSForm from '../components/CMSForm';
import CMSService from "../services/CMSService";
import { useLoading } from "../context/LoadingContext";
import { showErrorToast } from "../utils/AlertUtils";

const TermsCondition = () => {
  const { setIsLoading } = useLoading();
  const [ cmsData, setCMSData] = useState([]); 

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await CMSService.getCMS('terms-conditions');
      if(response && response.statusCode === 200) {
        setCMSData(response?.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
      showErrorToast(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <div>
      <CMSForm cmsData={cmsData}/>
    </div>
  );
};

export default TermsCondition;